<template>
  <div class="power-put">
    <div>
      <span class="trend-title1">各类投入</span>
      <div class="power-put-any">
        <span class="trend-title">资金</span>
        <el-input type="text" placeholder="请输入" v-model="money"></el-input>
        <span class="trend-title">技术</span>
        <el-input type="text" placeholder="请输入" v-model="tech"></el-input>
        <span class="trend-title">管理</span>
        <el-input type="text" placeholder="请输入" v-model="manage"></el-input>
        <span class="trend-title">设备</span>
        <el-input type="text" placeholder="请输入" v-model="device"></el-input>
        <span class="trend-title">人力</span>
        <el-input type="text" placeholder="请输入" v-model="people"></el-input>
      </div>
    </div>
    <div style=" margin-top: 3rem;">
      <span class="trend-title1">历年总投入</span>
      <el-button @click="addNewPut" style="margin:0 0 20px 20px" size="small" type="success" icon="el-icon-plus">添加年份</el-button>
    </div>
    <div class="save-box">
      <div v-for="(msg,index) in newPutDate" :key="index" class="power-put-year">
        <el-date-picker
          value-format="yyyy"
          v-model="msg.energyYear"
          type="year"
          placeholder="选择日期时间">
        </el-date-picker>
        <el-input type="number" placeholder="请输入" v-model="msg.fundInput">
           <template slot="suffix">万元</template>
        </el-input>
        <el-button @click="removeNewPut(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
    </div>
    <div class="last-save">
      <el-button :loading="newPutLoading" size="small" @click="saveNewPut" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      newPutLoading:false,//加载状态
      linshiID:'',//id
      money:'',//资金
      tech:'',//技术
      manage:'',//管理
      device:'',//设备
      people:'',//人力
      newPutDate:[],
    }
  },
  mounted(){
    this.getNewPut()
  },
  methods:{
    //保存数据
    saveNewPut(){
      this.newPutLoading = true;
      let obj = {}
      obj.years = this.newPutDate
      obj.energyInput = {
        artInput:this.tech,
        equipInput:this.device,
        fundInput:this.money,
        humanInput:this.people,
        manageInput:this.manage,
        energyYear:new Date().getFullYear()
      }
      if(this.linshiID){
        obj.energyInput.id = this.linshiID
      }
      apis.saveInput(obj).then(res=>{
        if(res.code==10000){
          this.newPutLoading = false;
          this.getNewPut()
          this.$message.success('保存成功')
        }else{
          this.$message.error(res.message)
          this.newPutLoading = false;
          return;
        }
      })
    },
    //获取数据
    getNewPut(){
      //列表
      apis.getInput({year:''}).then(res=>{
        if(res.code==10000){
          if(res.data.length!=0){
            this.newPutDate = (res.data).reverse()
          }else{
            this.newPutDate = []
          }
        }
      })
      //各项投入
      apis.getInputZB().then(res=>{
        if(res.code==10000){
          this.money = res.data[0].fundInput
          this.tech = res.data[0].artInput
          this.device = res.data[0].equipInput
          this.people = res.data[0].humanInput
          this.manage = res.data[0].manageInput
          this.linshiID = res.data[0].id
        }
      })
    },
    //添加一行投入
    addNewPut(){
      this.newPutDate.push({energyYear:'',fundInput:''})
    },
    //删除一行投入
    removeNewPut(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apis.delInput([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getNewPut()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.newPutDate.splice(index,1)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.power-put{
  .trend-title1{ font-weight: bold; color: #24ffb1; font-size: .9rem; padding-left: 10px; border-left: #24ffb1 solid 5px; display: inline-block; margin: .4rem 0 .6rem;}
  .power-put-any{
    .el-input,.el-select{ width: 8rem;}
  }
  .save-box{
    .power-put-year{ margin-bottom: 15px;}
    .el-input,.el-select{ width: 10rem;}
  }
}
</style>